import api from './api';

const mockRequests = false;

const returnAsPromise = (mock) => {
  return new Promise((resolve) => resolve(mock));
};

const insuranceCardInfos = {
  data: {
    cardNo: { vekaNo: '80756000080072505869', covercardNo: null },
    ZSRno: 'E058810',
    qualifyingDate: '2022-06-24',
    queryNumber: '1109151741',
    validCard: '1',
    'CH-Baseinformation': {
      identificationData: {
        name: { officialName: 'Biolley', firstname: ['Stéphane'] },
        nationalRepresentationOfName: null,
        dateOfBirth: {
          yearMonthDay: '1988-03-31',
          yearMonth: null,
          year: null
        },
        cardholderIdentifier: 7561318814367,
        sex: '1'
      },
      administrativeData: {
        issuingStateIdNumer: 'CH',
        nameOfTheInstitution: 'CSS Versicherung',
        identificationNumberOfTheInstitution: '8',
        insuredPersonNumber: '80756000080072505869',
        expiryDate: '2024-05-31',
        additionalAdminData: {
          accessRight: null,
          zsrAdditionalInfo: [],
          eMail: null,
          insurantNo: '892-92-067',
          methodOfPayment: null,
          keyValueParam: []
        }
      },
      nationalExtension: {
        mailAddress: {
          addressLine1: null,
          addressLine2: null,
          street: 'Route du Molard 19',
          houseNumber: null,
          dwellingNumber: null,
          postOfficeBoxNumber: null,
          postOfficeBoxText: null,
          locality: null,
          town: 'Praz (Vully)',
          swissZipCode: 1788,
          swissZipCodeAddOn: null,
          swissZipCodeId: null,
          foreignZipCode: null,
          country: 'CH'
        },
        KVGInformation: {
          languageRegion: 'fr',
          KVGModel: '06',
          KVGModelText: 'AOS Callmed',
          KVGcanton: { KVGcanton: 'FR', unknown: null, foreignCountry: null },
          KVGaccidentCoverage: '02',
          additionalKVGData: {
            accessRight: null,
            additionalInfo: ["Remplacez l'original par des génériques"],
            serviceDisabled: '0',
            keyValueParam: []
          }
        },
        insurerInformation: {
          contactNumberGerman: '0844 277 777',
          contactNumberFrench: null,
          contactNumberItalian: null,
          contactEmailAddress: null,
          contactEanNumber: '7601003001082',
          billingAddress: {
            addressLine1: 'CSS Assurance',
            addressLine2: 'Contact Center',
            street: 'Case postale',
            houseNumber: null,
            dwellingNumber: null,
            postOfficeBoxNumber: null,
            postOfficeBoxText: null,
            locality: null,
            town: 'Lucerne',
            swissZipCode: 6002,
            swissZipCodeAddOn: null,
            swissZipCodeId: null,
            foreignZipCode: null,
            country: 'CH'
          }
        },
        VVGInformation: [
          {
            VVGinsurerInformation: {
              nameOfVVGInsurer: 'CSS Versicherung',
              insurerInformation: {
                contactNumberGerman: '0844 277 777',
                contactNumberFrench: null,
                contactNumberItalian: null,
                contactEmailAddress: null,
                contactEanNumber: '7601003001082',
                billingAddress: {
                  addressLine1: 'CSS Assurance',
                  addressLine2: 'Contact Center',
                  street: 'Case postale',
                  houseNumber: null,
                  dwellingNumber: null,
                  postOfficeBoxNumber: null,
                  postOfficeBoxText: null,
                  locality: null,
                  town: 'Lucerne',
                  swissZipCode: 6002,
                  swissZipCodeAddOn: null,
                  swissZipCodeId: null,
                  foreignZipCode: null,
                  country: 'CH'
                }
              }
            },
            medicationHL: '01',
            medicationAccidentCoverageHL: '01',
            medicationKM: '02',
            medicationAccidentCoverageKM: '01',
            medicalServiceCoverageVVG: '01',
            hospitalModelVVG: '40',
            accidentCoverageVVG: '01',
            additionalVVGData: {
              medicalDataAccessRight: null,
              hospitalDataAccessRight: null,
              medicalAdditionalInfo: [],
              hospitalAdditionalInfo: [],
              hospitalRestriction1: null,
              hospitalRestriction2: null,
              hospitalRestriction3: null,
              coverageDisabled: '0',
              keyValueParam: []
            }
          }
        ]
      }
    }
  }
};

export function sendNumber(insuranceCardNumber, expirationDate) {
  if (mockRequests) {
    return returnAsPromise(insuranceCardInfos);
  }
  return api.get(
    `/api/v1/inscardinfo?card_no=${insuranceCardNumber}&expiry_date=${expirationDate}`
  );
}
